import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';

import { useAuth } from '@flipster/features/src/shared/auth/state';
import { useDepositModal } from '@flipster/features/src/shared/wallet-modal/deposit';
import { usePathname } from '@flipster/i18n/routing';
import { useOverlay } from '@flipster/overlay';
import { Button } from '@flipster/react/design-system/button';
import { IconButton } from '@flipster/react/design-system/icon-button';
import MenuIcon from '@flipster/react/icon/generated/MenuIcon';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';
import { css } from '@flipster/styled-system/css';
import { token } from '@flipster/styled-system/tokens';
import segment, { SessionEvent } from '@flipster/utils/segment';

import { promotionBunja } from '@web/app/_layout/navigation/promotion';

// 유저에서 바로 보여지지 않기때문에 dynamic loading
const MobileDrawer = dynamic(() => import('./mobile-drawer').then((mod) => mod.MobileDrawer), { ssr: false });

const hideSignUpPage = ['/signup', '/login'];

export const MobileMenu = () => {
  const t = useTranslations();
  const pathname = usePathname();

  const { isLoggedIn } = useAuth();
  const overlay = useOverlay();
  const isMounted = useMounted();
  const openDepositModal = useDepositModal();
  const { promotionAtom } = useBunja(promotionBunja);
  const promotion = useAtomValue(promotionAtom);

  const isShowSignUp = isMounted && !isLoggedIn && !hideSignUpPage.includes(pathname);
  const isShowDeposit = isMounted && isLoggedIn;

  const handleMenuClick = () => {
    overlay.open(
      ({ isOpen, onClose, unmount }) => (
        <MobileDrawer isOpen={isOpen} onClose={onClose} promotion={promotion} onExit={unmount} />
      ),
      'drawer',
    );
    segment.track(SessionEvent.GnbHamburgerClick);
  };

  return (
    <div className={css({ display: { base: 'flex', smallDesktop: 'none' }, direction: 'row', gap: 16 })}>
      {isShowSignUp && (
        <Button
          label={t('Autogen_common.r251126.s_Sign_up')}
          as='a'
          href='/signup'
          size='small'
          onClick={() => segment.track(SessionEvent.GnbLoginClick, { button_text: 'Sign up' })}
        />
      )}
      {isShowDeposit && <Button label={t('Common.r251107.Deposit')} size='small' onClick={() => openDepositModal()} />}
      <IconButton
        hierarchy='quaternary'
        icon={<MenuIcon color={token('colors.content.default.level-5')} />}
        onClick={handleMenuClick}
      />
    </div>
  );
};
